module.exports = __webpack_public_path__ + "static/media/SC.74bd1af9.svg";